import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateCompoundDialogComponent } from './create-compound-dialog.component';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { DatepickerInputModule } from 'src/app/shared/components/datepicker-input/datepicker-input.module';
import { AutocompleteModule } from 'src/app/shared/autocomplete/autocomplete.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormattedDatePipe } from 'src/app/shared/pipes/formatted-date/formatted-date.pipe';



@NgModule({
  declarations: [CreateCompoundDialogComponent],
  imports: [
    CommonModule,
    DialogModule,
    InputModule,
    DatepickerInputModule,
    AutocompleteModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [FormattedDatePipe],
  exports: [CreateCompoundDialogComponent],
})
export class CreateCompoundDialogModule { }
